/**
 * What a screen says when a read failed, decided by the status the console answered
 * with — never one sentence for every failure.
 *
 * 🔴 «Visible to admins only» is true of a 403 and of nothing else. Said on a 500, a
 * non-JSON answer or a dropped connection, it sends an admin looking for a role they
 * already hold (the TikTok console's map of the SPA's second wave,
 * audits/2026-10-20/SUMMARY.md at 09:59–10:00Z). So the refusal sentence is
 * the screen's own, passed in, and used for 403 alone; every other status says that the
 * read failed and how, and the worker's text (`why`) stays beside it on the screen.
 */

export interface ReadFailure {
	variant: "warning" | "danger";
	title: string;
}

export function readFailure(
	status: number | null,
	subject: {
		/** What was being read, as a sentence subject: «Teams», «The trail». */
		what: string;
		/** The screen's sentence for a 403: who may read this. */
		forbidden: string;
	},
): ReadFailure {
	if (status === 403) return { variant: "warning", title: subject.forbidden };
	if (status === null)
		return {
			variant: "danger",
			title: `${subject.what} could not be read: the console did not answer.`,
		};
	return {
		variant: "danger",
		title: `${subject.what} could not be read: the console answered ${status}.`,
	};
}
